import React, { useRef, useState, useEffect } from "react";

import BlogsService from "../Services/blogs.service";
import { useNavigate } from "react-router-dom";

import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";

const Blogs = () => {
  const [blogs, setBlogs] = useState([]);

  const navigate = useNavigate();

  const fetchBlogs = () => {
    BlogsService.fetchBlogsData()
      .then((response) => {
        if (response.data) {
          // console.log(response.data);
          // const latestBlogs = response.data.slice(-5);
          setBlogs(response.data);
        } else {
          console.error("No blog found with the specified id");
        }
      })
      .catch((error) => {
        console.error("There was a problem with the fetch operation:", error);
      });
  };

  useEffect(() => {
    fetchBlogs();
  }, []);

  const handleBlogClick = (item) => {
    navigate("/blog", { state: { blogId: item.id } });
  };

  const carouselRefNew = useRef();

  const goPrev = () => {
    carouselRefNew.current.prev(); // OwlCarousel API
  };

  const goNext = () => {
    carouselRefNew.current.next();
  };

  const options = {
    margin: 0,
    responsiveClass: true,
    nav: false,
    dots: true,
    autoplay: true,
    navText: ["←", "→"],
    smartSpeed: 1000,
    responsive: {
      0: {
        items: 1, // Changed mainBlogs to items
      },
      600: {
        items: 2.5, // Changed mainBlogs to items
      },
      768: {
        item: 2.5,
      },
      1024: {
        items: 2.50, // Changed mainBlogs to items
      },
      1280: {
        items: 3,
      },
      1366: {
        items: 4,
      },
      1920: {
        items: 5,
      },
    },
  };

 


  return (
    <>
      <section className="blogs" id="section13">
        <div className="container-fluid" id="blogs">
          <div className="row">
            <div className="col-lg-12">
              <div className="heading">
                <h1>Blogs</h1>
              </div>
            </div>
          </div>

          <div className="blogs-outer">
            <OwlCarousel className="owl-theme" ref={carouselRefNew} {...options} loop>
              {Array.isArray(blogs) && blogs.length > 0
                ? blogs.map((item) => (
                    <div className="blog-item" key={item.id}>
                      <div className="blog">
                        <img
                          src={`https://fidusindia.in/cit/assets/blog_images/${item.image}`}
                          alt=""
                        />
                        <div className="content">
                          <h5>{item.title}</h5>
                          <button className="blog-btn" onClick={() => {
                              handleBlogClick(item);
                            }}>Learn More</button>
                          
                        </div>
                        <div className="overlay3"></div>
                      </div>
                    </div>
                  ))
                : null}
            </OwlCarousel>

             <div class="owl-nav">
                <button
                  type="button"
                  className="owl-prev"
                  aria-label="Previous"
                  onClick={goPrev}
                >
                  ←
                </button>
                <button
                  type="button"
                  className="owl-next"
                  aria-label="Next"
                  onClick={goNext}
                >
                  →
                </button>
              </div>


          </div>

          {/* <div className="blogs-outer">
            <div className="carousel-container mb-3">
              <div className="carousel-track carousel-track1">
                {Array.isArray(blogs)
                  ? blogs.map((item) => {
                      return (
                        <>
                          <div className="blog">
                            <img
                              src={`https://fidusindia.in/cit/assets/blog_images/${item.image}`}
                            />
                            <div className="content">
                              <h5>{item.title}</h5>
                              <a
                                href=""
                                aria-label="Learn more about the blog"
                                onClick={() => {
                                  handleBlogClick(item);
                                }}
                              >
                                Learn More
                              </a>
                            </div>
                            <div className="overlay3"></div>
                          </div>
                        </>
                      );
                    })
                  : null}
              </div>
            </div>
          </div> */}
        </div>
      </section>
    </>
  );
};

export default Blogs;
